const firebaseConfig = {
  apiKey: "AIzaSyCQ1YFXz8t57baTAkWk9UEds6sicdHio8M",
  authDomain: "creative-agency-port.firebaseapp.com",
  databaseURL: "https://creative-agency-port.firebaseio.com",
  projectId: "creative-agency-port",
  storageBucket: "creative-agency-port.appspot.com",
  messagingSenderId: "13526620211",
  appId: "1:13526620211:web:6257dfe118599a45bc6b46"
};
  export default firebaseConfig;